import { Popover, PopoverContent, PopoverTrigger } from "Components/ui/popover";
import UseInnerWidth from "hooks/UseInnerWidth";
import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

function WalletDropDown({ title, data, selected, setSelected }) {
  const [open, setOpen] = useState(false);

  const width = UseInnerWidth();

  return (
    <Popover open={open} onOpenChange={() => setOpen(!open)}>
      <PopoverTrigger
        className={`bg-background border-2 border-border-darkNew px-4 py-[6px] rounded-lg ${
          width < 600 && "w-full"
        }`}
      >
        <div
          className={`flex flex-row items-center gap-2 text-base ${
            width < 600 && "justify-between"
          }`}
        >
          {title}
          <ChevronDown size={"1.2rem"} />
        </div>
      </PopoverTrigger>
      <PopoverContent>
        {data?.map((item, index) => {
          return (
            <div
              key={index}
              className="flex flex-row  justify-between items-center "
            >
              <div
                className={`${
                  selected === item?.value && "bg-background-opacity"
                } text-sm font-N_Roman cursor-pointer hover:bg-background-opacity w-full  py-2 px-4 rounded-md`}
                onClick={() => {
                  setOpen(false);
                  setSelected(item.value);
                }}
              >
                {item.label}
              </div>
            </div>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}

export default WalletDropDown;
